import "./config"
import { setup as setupLibrary } from "./icons"
import { setup as setupCocoonWatcher } from "./cocoon"
import { setup as setupDOMWatcher } from "./dom-watcher"

export function start() {
  setupLibrary();
  setupDOMWatcher();
}